import {NgModule, Optional, SkipSelf} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {AuthGuard} from './guard/auth.guard';
import {throwIfAlreadyLoaded} from './guard/module-import.guard';
import {LoggerService} from '@app/service/logger/logger.service';
import {LogPublishersService} from '@app/service/logger/log-publishers.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {StorageService} from '@app/service/util/storage.service';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';
import {NoAuthGuard} from '@app/guard/no-auth.guard';

@NgModule({
  imports: [
    HttpClientModule,
    NgxWebstorageModule.forRoot(),
    NzModalModule,
    NzDrawerModule
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    LoggerService,
    LogPublishersService,
    NzNotificationService,
    StorageService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
